import React from 'react';
import styled from 'styled-components';
import { MemberType } from '../../shared/enum/EnumRepository';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { useMemberCreditStore } from '../../shared/store/memberCreditStore';
import { useSettingStore } from '../../shared/store/settingStore';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import MemberCreditSelect from './MemberCreditSelect';

const MemberCreditInViewer: React.FC = () => {
  const { isEditMode } = useEditMode();
  const setting = useSettingStore((s) => s.setting);
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const updateActiveWork = useWorkViewStore((s) => s.updateActiveWork);
  const credits = useMemberCreditStore((s) => s.credits);

  if (!activeWork || setting?.memberType !== MemberType.GROUP) return null;
  if (!isEditMode && !activeWork.credit) return null;

  return (
    <CreditRow>
      <CreditLabel>Managed by</CreditLabel>
      {isEditMode ? (
        <MemberCreditSelect
          value={activeWork.credit?.id ?? null}
          credits={credits}
          onChange={(creditId) => {
            const credit = credits.find((each) => each.id === creditId) ?? null;
            updateActiveWork({ credit });
          }}
        />
      ) : (
        <CreditValue>{activeWork.credit?.name ?? ''}</CreditValue>
      )}
    </CreditRow>
  );
};

export default MemberCreditInViewer;

const CreditRow = styled.div`
  min-height: 18px;
  margin-bottom: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.typography.Body_04};
`;

const CreditLabel = styled.span`
  min-width: 70px;
  padding-top: 2px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  font-weight: 500;
`;

const CreditValue = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.2;
`;
